import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { BannerWrapper } from './SocialProofBanner.styles';
import { useViewContext } from '../View';
import { useTranslation } from '@shared/core';

export const SocialProofBanner: React.FC<{}> = () => {
  const { currentView } = useViewContext();
  const { t } = useTranslation('createWedding');
  const translations = t('signIn');

  if (currentView !== 'createAccount') {
    return null;
  }

  return (
    <BannerWrapper backgroundColor="#FFF9F5" marginTop={0} alignItems="center" justifyContent="center">
      <TextV2 textAlign="center" fontWeight={300} fontFamily="'Austin News Deck Web'" fontSize={'1.25rem'}>
        {translations.socialProofBanner()}
      </TextV2>
    </BannerWrapper>
  );
};
